<div class="w-full h-full flex flex-col justify-start items-center overflow-hidden">
    @if (currentUserService.currentSubscription()) {
    <div class="grid grid-cols-3 items-stretch gap-x-4 gap-y-4 h-full w-full overflow-hidden">

        <article class="col-span-2 h-full min-h-0 flex flex-col gap-y-4 overflow-hidden">

            <!-- Trial Countdown Card -->
            @if (currentUserService.subscriptionActive() === true && currentUserService.currentSubscription() &&
            currentUserService.currentSubscription()!.status == 'trialing') {
            <div
                class="rounded-lg border border-primary/20 bg-accent p-2 shadow-sm flex flex-row items-center justify-between">
                <div class="flex items-center">
                    <div class="shrink-0">
                        <div
                            class="size-12 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-8">
                                <path d="M12 6v6l4 2" />
                                <path d="M20 12v5" />
                                <path d="M20 21h.01" />
                                <path d="M21.25 8.2A10 10 0 1 0 16 21.16" />
                            </svg>
                        </div>
                    </div>
                    <div class="ml-4">
                        <h3 class="text-base font-semibold text-foreground">{{
                            currentUserService.trialCountdownDaysLabel() }}</h3>
                        <p class="text-sm text-muted-foreground">
                            Add card details now to avoid losing access. Cancel anytime.
                        </p>
                    </div>
                </div>
                <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
                    @if (showSharePaymentLinkModal() && !paymentLink()) {
                    <span
                        class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                        <svg aria-hidden="true"
                            class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>

                        Preparing Link...
                    </span>
                    } @else {
                    <button (click)="sendPaymentToTeam()" type="button"
                        class="relative inline-flex gap-x-1.5 items-center primary-button">
                        Share Payment Link
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="-ml-0.5 size-5">
                            <path
                                d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
                            <path d="m21.854 2.147-10.94 10.939" />
                        </svg>
                    </button>
                    }
                </div>
            </div>
            }
            <!-- Trial Countdown Card - END -->

            <!-- Purple Top Card -->
            <div
                class="shrink-0 overflow-hidden bg-linear-to-br from-brand-purple to-brand-agency-dark dark:from-brand-agency dark:to-brand-deep-purple rounded-lg p-2 shadow-md">

                <div class="flex flex-wrap items-center justify-between sm:flex-nowrap px-4">

                    <div class="flex items-center">
                        <div class="shrink-0">
                            <div
                                class="relative size-10 rounded-xl text-sm font-semibold flex items-center justify-center bg-white/15 text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path d="M4 20a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
                                    <path d="m12.474 5.943 1.567 5.34a1 1 0 0 0 1.75.328l2.616-3.402" />
                                    <path d="m20 9-3 9" />
                                    <path d="m5.594 8.209 2.615 3.403a1 1 0 0 0 1.75-.329l1.567-5.34" />
                                    <path d="M7 18 4 9" />
                                    <circle cx="12" cy="4" r="2" />
                                    <circle cx="20" cy="7" r="2" />
                                    <circle cx="4" cy="7" r="2" />
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4">
                            <h3 class="text-base font-semibold text-white">Essential Plan</h3>
                            <p class="text-sm text-white/80">
                                Monthly Billing
                            </p>
                        </div>
                    </div>

                    <div class="flex shrink-0">
                        <div class="flex flex-col items-end justify-end">
                            <dt class="text-sm/6 text-white/80">/month</dt>
                            <dd class="order-first text-xl font-semibold tracking-tight text-white">
                                {{ getBaseSubPrice() | currency:
                                currentUserService.currentSubscription().currency.toUpperCase() }}@if (isGbpBilling()) { (inc. VAT)}</dd>
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-row items-center gap-x-4 px-4 py-4">


                    <div class="flex-1 flex flex-row items-center rounded-lg bg-white/20 border border-white/25 p-2">
                        <div class="shrink-0">
                            <div
                                class="relative size-10 rounded-xl text-sm font-semibold flex items-center justify-center bg-white/15 text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path d="M8 2v4" />
                                    <path d="M16 2v4" />
                                    <rect width="18" height="18" x="3" y="4" rx="2" />
                                    <path d="M3 10h18" />
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4">
                            <h3 class="text-sm text-white/80">Next billing date</h3>
                            <p class="text-base font-semibold text-white">
                                {{
                                convertDate(currentUserService.currentSubscription().items.data[0].current_period_end) |
                                date: 'dd MMM yyyy' }}
                            </p>
                        </div>
                    </div>


                    <div (click)="goToStripe()"
                        class="flex-1 flex flex-row items-center rounded-lg bg-white/20 border border-white/25 p-2 hover:cursor-pointer hover:bg-white/30">
                        <div class="shrink-0">
                            <div
                                class="relative size-10 rounded-xl text-sm font-semibold flex items-center justify-center bg-white/15 text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <rect width="20" height="14" x="2" y="5" rx="2" />
                                    <line x1="2" x2="22" y1="10" y2="10" />
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4 flex-1">
                            <h3 class="text-sm text-white/80">Go to Stripe</h3>
                            <p class="text-base font-semibold text-white">
                                Manage Payment Method
                            </p>
                        </div>
                        <div class="shrink-0">
                            <button type="button" class="rounded-full bg-transparent p-1.5 text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Purple Top Card - END -->

            <!-- Bolt Ons Card -->
            <div class="flex-1 min-h-0 flex flex-col overflow-hidden shadow-card-container-pale">
                <div
                    class="shrink-0 flex flex-wrap items-center justify-between sm:flex-nowrap border-b border-gray-900/5 p-2 pb-4 dark:border-white/10">
                    <div class="">
                        <h3 class="text-base font-semibold text-primary">Bolt-ons</h3>
                        <p class="mt-1 text-sm text-secondary">{{
                            getActiveBoltOnCount() }} active | {{
                            getTotalPrice() - getBaseSubPrice() | currency:
                            currentUserService.currentSubscription().currency.toUpperCase() }}/month</p>
                    </div>
                    @if (currentUserService.currentSubscription().items.data.length > 1) {
                    <div class="shrink-0">
                        <button (click)="subscribe()" type="button"
                            class="relative inline-flex gap-x-1.5 items-center primary-button">
                            Add bolt-on
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="-ml-0.5 size-5">
                                <path d="M5 12h14" />
                                <path d="M12 5v14" />
                            </svg>
                        </button>
                    </div>
                    }
                </div>
                <div class="w-full flex flex-1 min-h-0 flex-col gap-y-4 px-2 py-2 overflow-y-auto scrollbar-transparent">
                    @if (currentUserService.currentSubscription().items.data.length > 1) {
                    <ul role="list" class="divide-y divide-gray-100 dark:divide-white/5">
                        @for (boltOn of currentUserService.currentSubscription().items.data; track $index) {
                        <li [hidden]="hideBaseSub(boltOn)" class="relative flex justify-between gap-x-6 py-2">
                            <div class="flex min-w-0 gap-x-4">
                                <div
                                    class="shrink-0 size-8 rounded-lg bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6 text-zinc-600 dark:text-white">
                                        <path
                                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                    </svg>
                                </div>
                                <div class="min-w-0 flex-auto">
                                    <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">
                                        {{ boltOnDisplayName(boltOn) }}
                                    </p>
                                    <p class="mt-1 flex text-xs/5 text-gray-500 dark:text-gray-400">
                                        <a href="mailto:leslie.alexander@example.com"
                                            class="relative truncate hover:underline">{{
                                            boltOn.price.product.description || 'Bolt-on' }}</a>
                                    </p>
                                </div>
                            </div>
                            <div class="flex shrink-0 items-center gap-x-4">
                                <div class="hidden sm:flex sm:flex-col sm:items-end">
                                    <p class="text-sm/6 text-gray-900 dark:text-white">{{ getBoltOnPrice(boltOn) |
                                        currency: 'GBP' }}</p>
                                    <p class="mt-1 text-xs/5 text-gray-500 dark:text-gray-400">{{
                                        getBillingPeriod(boltOn) }}</p>
                                </div>
                                @if (removingBoltOnId() === boltOn.id) {
                                <svg aria-hidden="true" class="size-5 flex-none text-gray-400 animate-spin"
                                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor" />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill" />
                                </svg>
                                } @else {
                                <button type="button" (click)="removeBoltOn(boltOn)"
                                    [disabled]="removingBoltOnId() !== null"
                                    class="rounded-full p-1 text-gray-400 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    aria-label="Remove bolt-on">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5" aria-hidden="true">
                                        <path d="M18 6 6 18" />
                                        <path d="m6 6 12 12" />
                                    </svg>
                                </button>
                                }
                            </div>
                        </li>
                        }
                    </ul>
                    } @else {
                    <div class="flex flex-1 flex-col items-center justify-center py-8 text-center">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"
                            class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                            <path
                                d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                stroke-width="2" vector-effect="non-scaling-stroke" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No Bolt-ons</h3>
                        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Add bolt-ons to supercharge your
                            workflow.
                        </p>
                        <div class="mt-6 flex justify-center">
                            <button (click)="subscribe()" type="button"
                                class="relative inline-flex gap-x-1.5 items-center primary-button">
                                Choose Bolt-ons
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="-ml-0.5 size-5">
                                    <path d="M5 12h14" />
                                    <path d="M12 5v14" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    }

                </div>
            </div>
            <!-- Bolt Ons Card - END -->

        </article>
        <article class="col-span-1 h-full min-h-0 flex flex-col overflow-hidden">

            <div class="h-full overflow-hidden shadow-card-container-pale">
                <div class="flex items-center gap-x-4 border-b border-gray-900/5 p-2 pb-4 dark:border-white/10">
                    <img src="https://tailwindcss.com/plus-assets/img/logos/48x48/tuple.svg" alt="Tuple"
                        class="size-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10 dark:bg-gray-700 dark:ring-white/10" />
                    <div class="text-md font-medium text-gray-900 dark:text-white">Subscription Details</div>

                </div>
                <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm/6 dark:divide-white/10">

                    <div class="flex justify-between gap-x-4 py-3">
                        <dt class="text-gray-500 dark:text-gray-400">Status</dt>
                        <dd class="text-gray-700 dark:text-gray-300 capitalize"
                            [class]="getStatusClass(currentUserService.currentSubscription().status)">{{
                            currentUserService.currentSubscription().status }}</dd>
                    </div>

                    <div class="flex justify-between gap-x-4 py-3">
                        <dt class="text-gray-500 dark:text-gray-400">Date Subscribed</dt>
                        <dd class="text-gray-700 dark:text-gray-300">{{
                            convertDate(currentUserService.currentSubscription().created) | date: 'dd MMM yyyy' }}</dd>
                    </div>
                    <div class="flex justify-between gap-x-4 py-3">
                        <dt class="text-gray-500 dark:text-gray-400">Last bill date</dt>
                        <dd class="text-gray-700 dark:text-gray-300">{{
                            convertDate(currentUserService.currentSubscription().items.data[0].current_period_start) |
                            date: 'dd MMM yyyy' }}</dd>
                    </div>
                    <div class="flex justify-between gap-x-4 py-3">
                        <dt class="text-gray-500 dark:text-gray-400">Next bill date</dt>
                        <dd class="text-gray-700 dark:text-gray-300">{{
                            convertDate(currentUserService.currentSubscription().items.data[0].current_period_end) |
                            date: 'dd MMM yyyy' }}</dd>
                    </div>
                </dl>

                <div
                    class="flex flex-row px-4 py-4 items-center justify-between border-t border-b border-gray-900/5 dark:border-white/10">
                    <h2 class="text-sm text-primary font-semibold">Monthly Total</h2>
                    <p
                        class="text-xl font-bold bg-linear-to-r from-brand-agency to-brand-studio bg-clip-text text-transparent">{{
                        getTotalPrice() | currency: currentUserService.currentSubscription().currency.toUpperCase()
                        }}@if (isGbpBilling()) { (inc. VAT)}</p>
                </div>

                <div class="w-full flex flex-col gap-y-4 px-4 py-4">
                    <h2 class="text-sm font-medium text-primary">Need help?</h2>

                    <button type="button" (click)="openContactSupport()"
                        class="inline-flex items-center justify-between rounded-md bg-white/10 px-3 py-2 text-sm ring-1 ring-inset ring-white/5 hover:bg-white/15 cursor-pointer text-primary font-normal">
                        Contact Support
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="-mr-0.5 size-5">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </button>

                    <button (click)="startOffboarding()" type="button"
                        class="inline-flex items-center justify-between rounded-md bg-white/10 px-3 py-2 text-sm ring-1 ring-inset ring-white/5 hover:bg-white/15 cursor-pointer text-primary font-normal">
                        Leaving Us?
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="-mr-0.5 size-5">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>


        </article>

    </div>
    } @else {
    <div class="h-full w-full overflow-hidden flex flex-col items-center justify-center">
        <!-- Header Section -->
        <div class="text-center pt-8 pb-6 px-4">

            <div
                class="mb-6 p-4 mx-auto h-16 w-16 rounded-full bg-linear-to-br from-primary to-brand-agency-dark text-white flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-10">
                    <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                    <path d="m16 12-4-4-4 4" />
                    <path d="M12 16V8" />
                    <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                    <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                    <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                    <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                </svg>
            </div>

            <h2 class="text-4xl sm:text-5xl font-bold text-zinc-900 dark:text-white mb-3">
                Subscribe to
                <span class="text-transparent bg-clip-text bg-linear-to-r from-[#ff80b5] to-[#9089fc]">thrive!</span>

            </h2>
            <p class="text-zinc-600 dark:text-zinc-400 text-sm sm:text-base max-w-xl mx-auto">
                You've not yet subscribed to a plan. Subscribe to get started with your UGC journey.
            </p>

            <button type="button" (click)="subscribe()" class="mx-auto mt-6 w-full max-w-lg flashy-go-button">Subscribe
                Now</button>
        </div>
    </div>
    }

</div>

@if (showSharePaymentLinkModal() && paymentLink()) {
<mb-share-payment-link (close)="showSharePaymentLinkModal.set(false)"
    [paymentLink]="paymentLink()!"></mb-share-payment-link>
}

@if (showContactSupportModal()) {
<mb-contact-support-modal (close)="showContactSupportModal.set(false)"></mb-contact-support-modal>
}